<template>
  <div v-if="getfundAnnouncementList(baseInfo).length > 0" class="fund-read-wrapper">
    <FTItem class="wrappertop"
    v-for="(item, index) in getfundAnnouncementList(baseInfo)"
    :content="item"
    :key="index">
    </FTItem>
  </div>
</template>

<script>

import FTItem from '@/components/Fund-Tip-item.vue';
import FundTypeSearch from '@/utils/FundTypeSearch';
import { mapGetters } from 'vuex';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  components: {
    FTItem,
  },
  data() {
    return {
      fundCode: '',
      fundReportData: {},
      showModule: [],
      closeIndex: [],
    };
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.handleDefault();
  },
  mounted() {},
  computed: {
    ...mapGetters({
      baseInfo: 'currentADConDate',
    }),
  },
  methods: {
    getContentList(richItem) {
      if (richItem.HotTitle.length === 0) {
        return richItem.Title;
      }
      const { HotTitle, Title } = richItem;

      const val = `###${HotTitle}###`;
      const regS = new RegExp(HotTitle, 'g');
      const con = Title.replace(regS, val);
      const strs = con.split('###'); // 定义一数组
      // console.log(`zxy --getContentList---- ${JSON.stringify({ a: strs })}`);
      return strs;
    },
    isExchangeFund() {
      return FundTypeSearch.isExchangeFund(this.fundType);
    },
    isNewFund() {
      return FundTypeSearch.isNewFund(this.fundType);
    },
    isMonetaryfund() {
      return FundTypeSearch.isMonetaryfund(this.fundType);
    },
    getConfigureDataState(item) {
      // FundType 1-权益 2-货币 3-场内 4-新发
      if (!item) {
        return false;
      }
      const {
        ExcludeCodes,
        FundType,
        IncludeCodes,
      } = item;
      if (IncludeCodes && IncludeCodes.indexOf) {
        if (IncludeCodes.indexOf(this.fundCode) !== -1) {
          return true;
        }
      }
      if (ExcludeCodes && ExcludeCodes.indexOf) {
        if (ExcludeCodes.indexOf(this.fundCode) !== -1) {
          return false;
        }
      }
      if (FundType) {
        const liststr = FundType;
        if (liststr.indexOf) {
          if (liststr.indexOf('1') !== -1) {
            if (!this.isNewFund() && !this.isExchangeFund() && !this.isMonetaryfund()) {
              return true;
            }
          }
          if (liststr.indexOf('2') !== -1) {
            if (this.isMonetaryfund()) {
              return true;
            }
          }
          if (liststr.indexOf('3') !== -1) {
            if (this.isExchangeFund()) {
              return true;
            }
          }
          if (liststr.indexOf('4') !== -1) {
            if (this.isNewFund()) {
              return true;
            }
          }
        }
      }
      return false;
    },
    getfundAnnouncementList(variInfo) {
      if (!variInfo) {
        return [];
      }
      let ModulesData = null;
      const { datas } = variInfo;
      if (datas) {
        if (datas.Modules) {
          ModulesData = datas.Modules;
        }
      }
      if (ModulesData) {
        const showModules = ModulesData.filter(
          (item) => (item.ModuleCode === 'FundDetailNotice' && item.CustomArray.length > 0),
        );
        if (showModules.length > 0) {
          const showModule = showModules[0];
          let { CustomArray } = showModule;
          CustomArray = CustomArray.filter((item) => item.Title).map((item) => {
            const result = item;
            return result;
          });
          console.log(CustomArray);
          return this.cutItemNotiNConfigure(CustomArray);
        }
      }
      return [];
    },
    cutItemNotiNConfigure(list) {
      const showls = [];
      if (!list) {
        return showls;
      }
      list.forEach((element) => {
        if (this.getConfigureDataState(element)) {
          showls.push(element);
        }
      });
      return showls;
    },
    closeWarning(index) {
      //
      // console.log(`zxy----closeWarning---${index}`);
      this.closeIndex.push(index);
    },
    async render() {
      // console.log('zxy --ad render--');
    },
    handleDefault() {},
    configureVideo() {
    },
    clickCell(item) {
      const { LinkType, LinkTo } = item.Link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      let ugid = item.UserGroupID;
      if (!ugid) {
        ugid = '';
      }
      // {location:跳转链接；groupid:定向用户组id}
      this.reportMonitor({
        eventName: 'pz.tbkp.zdhdrk.click',
        location: LinkTo,
        groupid: ugid,
        eventContent: {
          location: LinkTo,
          groupid: ugid,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">

.wrappertop {
  background: #f7e6d3;
  padding-left: 25px;
  display: flex;
  border-radius: 12px;
  margin-bottom: 24px;
}
.tipredleftimg{
  margin-left: 10px;
  height: 32px;
  width: 32px;
}
.fund-read-wrapper {
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 24px;
}

.fund-read {
  padding: 25px 24px 25px 0;
  justify-content: space-between;
  margin-left: 24px;
  border-bottom: 1px solid #f5f5f5;
  &:nth-last-child(1) {
    border-bottom: 1px solid #fff
  }
}

.fund-info {
  display: flex;
  align-items: center;
}
.item-fund-info {
  display: flex;
  margin-left: 20px;
  margin-right: 40px;
  flex-wrap:wrap;
  align-items: center;
}
.item-tip-title{
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #000000;
}
.read-title {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #000000;
  letter-spacing: 0;
  text-align: justify;
  margin-left: 10px;
  flex: 1;
}

.read-time {
  font-family: PingFangSC-Light;
  font-size: 24px;
  color: #666666;
  letter-spacing: 0;
  text-align: right;
}

.read-text {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
}
.small-tag {
  display: flex;
  border-radius: 4px;
  white-space: nowrap;  /*强制span不换行*/
  display: inline-block;  /*将span当做块级元素对待*/
  font-family: PingFangSC-Regular;
  font-size: 24px;
  letter-spacing: 0;
  padding-left:8px;
  padding-right:8px;
  height: 32px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  color: #4a90e2;
  background-color: rgba(74, 144, 226, 0.1);
}

.tag-blue {
  color: #4a90e2;
  background-color: rgba(74, 144, 226, 0.1);
}

.tag-red {
  color: #f45454;
  background-color: rgba(244, 84, 84, 0.1);
}

.tag-orange {
  color: #ff700e;
  background-color: rgba(255, 112, 14, 0.1);
}
.close_view {
  position:absolute;
  right: 30px;
  display: flex;
}

.close_img {
  width: 26px;
  height: 26px;
}
</style>
